import { createContext, useContext } from 'react';
export var ModalContext = createContext({
    modalProps: { isOpen: false, variant: 'default' },
    setModalProps: function () { },
});
export var ModalProvider = ModalContext.Provider;
export var useUpdateModal = function () {
    var setModalProps = useContext(ModalContext).setModalProps;
    return setModalProps;
};
